<template>
  <div :class="$style.formContainer">
    <LoginCard
      header="Reset your password"
    >
      <LoginActionButton
        :action="() => redirect(resetMacPassword)"
        :buttonType="buttonTypes.chooseOS"
      >
        <span :class="$style.buttonContentContainer">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 21" v-bind:svg-inline="''" :class="$style.osIcon" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M13.136.391c0 .98-.401 1.894-1.203 2.74-.969 1.005-2.138 1.588-3.408 1.496a2.915 2.915 0 01-.025-.372c0-.94.46-1.946 1.277-2.768.408-.417.926-.763 1.556-1.04.628-.271 1.222-.422 1.78-.447.016.13.023.26.023.391m3.508 15.231a11.14 11.14 0 01-1.085 1.957c-.57.816-1.038 1.381-1.398 1.695-.558.515-1.156.78-1.796.794-.46 0-1.015-.131-1.66-.397-.648-.266-1.243-.397-1.786-.397-.571 0-1.183.131-1.837.397-.656.266-1.184.404-1.588.418-.614.026-1.226-.245-1.837-.815-.39-.34-.877-.926-1.462-1.756-.627-.884-1.142-1.91-1.547-3.08C.218 13.174 0 11.95 0 10.766 0 9.41.293 8.238.877 7.257a5.159 5.159 0 011.838-1.865 4.931 4.931 0 012.486-.704c.487 0 1.127.152 1.922.45.792.297 1.301.449 1.524.449.168 0 .733-.177 1.691-.53.907-.327 1.671-.463 2.298-.41 1.699.138 2.973.81 3.822 2.02-1.518.923-2.27 2.217-2.255 3.875.014 1.292.482 2.367 1.4 3.22.415.397.88.704 1.397.921-.112.327-.23.638-.356.94" fill-rule="evenodd"/></svg>
          I use Mac
        </span>
      </LoginActionButton>
      <LoginActionButton
        :action="() => redirect(resetWindowsPassword)"
        :buttonType="buttonTypes.chooseOS"
      >
        <span :class="$style.buttonContentContainer">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" v-bind:svg-inline="''" :class="$style.osIcon" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M20 10.561L19.997 20 9.16 18.475l-.015-7.932L20 10.56zM9.16 1.576L19.997 0v9.482L9.16 9.567V1.576zm-.99 8.911l.007 7.866-8.17-1.12v-6.799l8.163.053zM0 2.831l8.173-1.11.005 7.861-8.17.046L0 2.831z" fill-rule="evenodd"/></svg>
          I use Windows
        </span>
      </LoginActionButton>
      <LoginActionButton
        :action="() => redirect(resetUserPassword)"
        :buttonType="buttonTypes.chooseOS"
      >
        <span :class="$style.buttonContentContainer">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 22" v-bind:svg-inline="''" :class="$style.osIcon" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path d="M2.63 20.57c1.185.136 2.516.88 3.63 1.01 1.12.137 1.467-.738 1.467-.738s1.26-.272 2.585-.304a11.2 11.2 0 012.582.267s.243.54.698.775c.454.24 1.432.273 2.06-.366.628-.644 2.304-1.456 3.246-1.963.947-.508.773-1.283.178-1.519-.594-.235-1.081-.607-1.044-1.32.032-.706-.525-1.177-.525-1.177s.488-1.555.033-2.843c-.454-1.283-1.953-3.345-3.105-4.895-1.153-1.555-.174-3.35-1.223-5.645C12.162-.445 9.442-.31 7.975.67c-1.466.98-1.017 3.408-.946 4.56.07 1.147.032 1.967-.103 2.262-.136.3-1.082 1.387-1.71 2.298-.627.916-1.082 2.806-1.541 3.586-.45.775-.136 1.482-.136 1.482s-.314.104-.562.613c-.243.502-.73.742-1.607.906-.87.173-.87.716-.66 1.324.21.607 0 .947-.244 1.722-.243.775.975 1.01 2.164 1.147zm12.315-3.536c.623.263 1.517-.104 1.79-.367.27-.262.462-.652.462-.652s.272.13.245.547c-.029.423.187 1.025.595 1.234.407.208 1.03.498.707.788-.329.29-2.146.998-2.69 1.55-.538.55-1.245.998-1.676.866-.435-.131-.815-.707-.628-1.55.193-.838.356-1.759.328-2.284-.028-.526-.135-1.234 0-1.338.136-.104.352-.054.352-.054s-.108.997.515 1.26zM10.907 2.832c.6 0 1.083.575 1.083 1.283 0 .503-.244.938-.6 1.147-.09-.036-.184-.077-.287-.119.216-.103.366-.366.366-.67 0-.398-.253-.726-.57-.726-.31 0-.568.328-.568.726 0 .145.037.29.098.404a25.807 25.807 0 00-.491-.186 1.52 1.52 0 01-.113-.576c0-.708.482-1.283 1.082-1.283zM9.422 5.044c.295.05 1.106.39 1.406.494.3.1.631.285.6.471-.038.192-.193.192-.6.432-.403.235-1.283.761-1.565.797-.28.036-.44-.117-.74-.304-.3-.19-.862-.635-.72-.87 0 0 .44-.326.631-.493.192-.173.688-.58.988-.527zM8.13 3.036c.472 0 .857.544.857 1.215 0 .122-.014.236-.037.35a.975.975 0 00-.348.19c-.055.045-.107.086-.153.13a.855.855 0 00.07-.534c-.066-.362-.319-.63-.567-.594-.25.04-.398.372-.338.739.066.371.314.64.567.599l.042-.014a3.1 3.1 0 01-.351.295c-.342-.155-.595-.617-.595-1.16 0-.676.379-1.216.853-1.216zm-2.632 8.78c.486-.743.8-2.366 1.287-2.906.492-.538.87-1.686.698-2.193 0 0 1.05 1.215 1.78 1.016.731-.205 2.375-1.387 2.619-1.184.243.204 2.337 4.66 2.548 6.08.21 1.418-.14 2.501-.14 2.501s-.802-.204-.905.267c-.103.476-.103 2.2-.103 2.2s-1.083 1.45-2.759 1.69c-1.676.236-2.516.064-2.516.064l-.941-1.043s.731-.105.628-.816c-.103-.707-2.235-1.686-2.619-2.566-.383-.88-.07-2.366.423-3.11zm-4.146 5.322c.084-.348 1.17-.348 1.588-.593.417-.245.501-.948.838-1.134.332-.19.946.485 1.2.866.247.371 1.198 1.995 1.587 2.399.393.407.754.947.641 1.432-.106.485-.698.839-.698.839-.528.157-2.003-.459-2.674-.73-.67-.273-2.375-.354-2.594-.594-.226-.245.108-.785.196-1.297.08-.517-.169-.839-.084-1.188z"/></svg>
          I use Linux
        </span>
      </LoginActionButton>
    </LoginCard>
  </div>
</template>

<script>
import { AdminRoutes } from 'client/routes/RouteGenerator';
import { LoginConsts } from 'client/util/Constants';
import LoginActionButton from 'client/components/LoginActionButton.vue';
import LoginCard from 'client/components/LoginCard.vue';
import loginUtil from 'client/components/mixins/loginUtil';

const { buttonTypes } = LoginConsts;
const { resetMacPassword, resetUserPassword, resetWindowsPassword } = AdminRoutes;

export default {
  name: 'ChooseOs',

  mixins: [loginUtil],

  components: {
    LoginActionButton,
    LoginCard,
  },

  props: {
    requestKey: {
      default: '',
      type: String,
    },
  },

  computed: {
    buttonTypes: () => buttonTypes,
    resetUserPassword() { return this.appendRequestKey(resetUserPassword); },
    resetMacPassword() { return this.appendRequestKey(resetMacPassword); },
    resetWindowsPassword() { return this.appendRequestKey(resetWindowsPassword); },
  },

  methods: {
    appendRequestKey(path) {
      return this.requestKey ? `${path}&key=${this.requestKey}` : path;
    },
  },
};
</script>

<style module>
@import '../css/login-components.css';

.buttonContentContainer {
  align-items: center;
  display: flex;
}

.osIcon {
  fill: currentColor;
  height: 24px;
  margin-right: 1em;
  width: 24px;
}
</style>
